import _ from 'lodash'
import localForage from 'localforage'

import BaseStore from '../Base'
import {AuthConstants} from '../auth'

import {Actions} from './Constants'

class OrganizationStore extends BaseStore {
   constructor() {
      super()

      this.subscribe(this._subscribe.bind(this))

      this._organizations = null

      localForage.getItem('organizations').then(organizations => {
         this._organizations = organizations
      })
   }

   emitChange() {
      localForage.setItem('organizations', this._organizations).then(() => {
         BaseStore.prototype.emitChange.call(this)
      })
   }

   _subscribe(action) {
      let idx

      // initialize
      if (null === this._organizations && _.some(Actions, action.actionType)) {
         this._organizations = []
      }

      switch (action.actionType) {
         case AuthConstants.Actions.logout:
            this._organizations = null
            localForage.removeItem('organizations')
            this.emitChange()
            break

         case Actions.new:
            this._organizations.push(action.organization)
            this.emitChange()
            break

         case Actions.change:
            idx = _.findIndex(this._organizations, {key: action.nid})

            if (-1 === idx) {
               return
            }

            this._organizations[idx] = action.organization
            this.emitChange()
            break

         case Actions.update:
            idx = _.findIndex(this._organizations, {key: action.nid})
            if (-1 === idx) {
               return
            }

            this._organizations[idx] = _.merge(this._organizations[idx], action.organization)
            this.emitChange()
            break

         case Actions.list:
            this._organizations = action.organizations
            this.emitChange()
            break

         default:
            break
      }
   }

   get organizations() {
      return _.clone(this._organizations)
   }

   organization(key) {
      return this._organizations ? _.where(this._organizations, {key: key})[0] : null
   }
}

export default new OrganizationStore()



// WEBPACK FOOTER //
// lib/api/organization/Store.js